import React, { useEffect } from 'react';
import HubblePageContainer from './components/HubblePageContainer';
import HubbleBlogFilter from './components/HubbleBlogFilter';

import HubbleAllBlogs from './components/HubbleAllBlogs';

import { useDispatch, useSelector } from "react-redux";
import BlogRequests from '../../assets/services/blog';
import { clearRbBlogs } from '../../assets/redux/actions/Blog';
import Loading from '../../assets/containers/loadingDialog';

const HubbleBlog = () => {
    const { fetchBlogsLoading } = useSelector(({ blog }) => blog);
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchData = async () => {
            try {
                dispatch(clearRbBlogs());
                await dispatch(BlogRequests.getAllblogs("Hubble", 1));
            } catch (error) {
                console.error(error);
            }
        };
        fetchData();
    }, [dispatch]);

    return (
        <HubblePageContainer>
            <HubbleBlogFilter />
            <section className='my-4'>
                {fetchBlogsLoading ? (
                    <Loading
                        className={"w-100 d-flex justify-content-center my-5 py-5"}
                        dark={true}
                    />
                ) : (
                    <HubbleAllBlogs />
                )}
                {/* <BlogListElement data={data[0]} purpleDark />
                <BlogListElement data={data[0]} purpleDark />
                <BlogListElement data={data[0]} purpleDark />
                <BlogListElement data={data[0]} purpleDark /> */}
            </section>
        </HubblePageContainer>
    )
}

export default HubbleBlog